import React from "react";

import tracking from "../../utils/tracking";
// import "./scss/ProductGrid.scss";
// import "./scss/Product.scss";
import './scss/prodGrid.scss'

import { TAGS, BODY_COPY } from "../../utils/content-keys";

import MobileGrid from "./mobile-grid";
import DesktopGrid from "./desktop-grid";
import ProductTile from "./product-tile";

export default class ProductGrid extends React.Component {
	componentDidMount() {
		tracking.pageView("/the-beers");
	}

	cleanString = title => {
		return (
			this.props.routeProps.match.url +
			"/" +
			title
				.split(" ")
				.join("-")
				.toLowerCase()
		);
	};

	ProductObj = function (product) {
		const productObj = product
		// for (let itemField of jsonItem.fields) {
		// 	if (itemField.id === 'itemname') {
		// 		item.name = itemField.value
		// 		continue
		// 	} else if (itemField.id === 'itemdescription') {
		// 		item.desc = itemField.value
		// 		continue
		// 	} else if (itemField.id === 'nutritioninfo') {
		// 		item.nutrition = itemField.value
		// 		continue
		// 	} else if (itemField.id === 'price') {
		// 		item.price = itemField.value
		// 		continue
		// 	} else if (itemField.id === 'image') {
		// 		item.img = itemField.imgURL
		// 		item.imgAlt = itemField.alternateText
		// 		continue
		// 	}
		// }
		return productObj
	}

	render() {
		const { products } = this.props;

		if (!products) {
			return null;
		}

		if (!Object.entries)
			Object.entries = function (obj) {
				var ownProps = Object.keys(obj),
					i = ownProps.length,
					resArray = new Array(i); // preallocate the Array
				while (i--)
					resArray[i] = [ownProps[i], obj[ownProps[i]]];

				return resArray;
			};

		let allProductsArr = []
		for (let [key, value] of Object.entries(products)) {
			console.log(`k: ${key}`)
			console.log(`v: ${value}`)
			allProductsArr.push(this.ProductObj(value))
			// for (let [key1, value1] of Object.entries(value)) {
			// 	console.log(`k1: ${key1}`)
			// 	console.log(`v1: ${value1}`)
			// 	if (key1.toLowerCase() === 'category') {

			// 	}
			// Category: [{ … }]
			// meta: { title: "Beer Tasting Notes for Guinness Pure Brew | Open Gate Brewery", description: "Educate your palate with these beer tasting notes …ed beer at the Open Gate Brewery. Book a tasting!", sortIndex: "4" }
			// Tags: [{ … }]
			// Header: [{ … }]
			// Characteristics: (4)[{ … }, { … }, { … }, { … }]
			// MaltsHops: (2)[{ … }, { … }]
			// Description: [{ … }]
			// Exclusive: []
			// for (let [key2, value2] of Object.entries(value1)) {
			// 	console.log(`k2: ${key2}`)
			// 	console.log(`v2: ${value2}`)
			// for (let [key3, value3] of Object.entries(value2)) {
			// 	console.log(`${key3}`)
			// 	console.log(`${value3}`)
			// }
			// }
			// }
		}

		console.log('allprod: ', allProductsArr)
		return (
			<div className="prodgrid">
				<div className='prodgrid__container list-group__container'>
					<div className='prodgrid__wrap'>
						{allProductsArr.map(product => {
							return <ProductTile product={product} />
						})}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/beers/ProductGrid.js